const fontSizeMedium = 'var(--fontSizeMedium, 0.875rem)'
import styled from 'astroturf/react'
import { HtmlParser } from '@calendly/html-parser'
import { Link } from '@calendly/ui/components/link'

import { useI18n } from 'locales'
import _TermsAndPrivacyNotice from "TermsAndPrivacyNotice.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/package/terms_and_privacy_notice.js?styleId=TermsAndPrivacyNotice";
import _StyledLink from "terms_and_privacy_notice-StyledLink.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/package/terms_and_privacy_notice.js?styleId=StyledLink";


const TosLink = ({ children }) => <StyledLink href="/pages/terms" target="_blank" rel="opener">{children}</StyledLink>
const PolicyLink = ({ children }) => <StyledLink href="/pages/privacy" target="_blank" rel="opener">{children}</StyledLink>

export const TermsAndPrivacyNotice = /*#__PURE__*/styled('p', null, {
  displayName: "TermsAndPrivacyNotice",
  styles: _TermsAndPrivacyNotice,
  attrs: props => ({
    ...props,
    children: HtmlParser(useI18n().i18n.t('booking.package.terms_and_privacy_notice'), {
      TosLink,
      PolicyLink
    })
  })
})

const StyledLink = /*#__PURE__*/styled(Link, null, {
  displayName: "StyledLink",
  styles: _StyledLink,
  attrs: props => ({
    ...props,
    underline: false
  })
})
